module.exports = __webpack_public_path__ + "img/user02.e4209033.png";